import type { TCMContent } from './schema';

export const defaultTcmContent: TCMContent = {
  siteConfig: {
    siteName: '明德中醫診所',
    doctorName: '徐醫師',
    doctorTitle: '註冊中醫師',
    whatsappNumber: '85262322466',
    whatsappDefaultMessage: '你好，我想預約診症',
    whatsappInquiryMessage: '你好，我想查詢門診時間',
    phone: '+852 2345 6789',
    address: '九龍旺角彌敦道 123 號',
    addressDetail: '旺角地鐵站 A2 出口，步行 3 分鐘',
    registrationNumber: 'TCM-12345',
    socialLinks: {
      facebook: 'https://facebook.com/mingde-tcm',
      youtube: '',
    },
  },
  navigationContent: {
    links: [
      { label: '關於醫師', href: '#about' },
      { label: '中醫介紹', href: '#tcm' },
      { label: '診療項目', href: '#services' },
      { label: '專業足跡', href: '#gallery' },
      { label: '常見問題', href: '#faq' },
      { label: '健康專欄', href: '#blog' },
      { label: '聯絡預約', href: '#contact' },
    ],
    ctaText: 'WhatsApp 預約',
  },
  heroContent: {
    heading: '傳統智慧，現代醫療',
    subheading: '明德中醫診所',
    tagline: '以人為本，辨證施治，為您提供專業中醫診療',
    primaryCta: {
      text: 'WhatsApp 預約',
      message: '你好，我想預約診症',
    },
    secondaryCta: {
      text: '了解更多',
      href: '#about',
    },
    trustBadges: [
      { icon: 'Shield', text: '註冊中醫師' },
      { icon: 'Clock', text: '20 年臨床經驗' },
      { icon: 'GraduationCap', text: '中醫藥大學畢業' },
    ],
    backgroundImage: 'https://pub-8d4e3c05979c4793884b7747c5e0e2b4.r2.dev/media/hero-bg.jpg',
  },
  aboutContent: {
    sectionTitle: '關於徐醫師',
    sectionSubtitle: '專業背景與臨床經驗',
    timelineTitle: '學經歷',
    timeline: [
      {
        year: '2003',
        title: '中醫藥大學畢業',
        desc: '主修中醫內科，獲學士學位',
      },
      {
        year: '2008',
        title: '註冊中醫師',
        desc: '通過香港中醫藥管理委員會註冊考試',
      },
      {
        year: '2015',
        title: '創立明德中醫診所',
        desc: '專注慢性病調理與亞健康治療',
      },
    ],
    philosophyTitle: '診療理念',
    philosophyCards: [
      {
        title: '辨證施治',
        subtitle: '個人化治療方案',
        desc: '根據每位患者的體質、症狀、生活習慣，制定專屬治療方案',
      },
      {
        title: '中西結合',
        subtitle: '現代醫學輔助',
        desc: '結合現代醫學檢查，提高診斷準確性',
      },
      {
        title: '預防為先',
        subtitle: '養生保健指導',
        desc: '提供飲食、運動、作息建議，預防疾病復發',
      },
    ],
    doctorImage: 'https://pixabay.com/get/g3747ad106cd4e384b4660c6cce8ccf6701c13f1e5fe887b6d10ac62126fb275b39b8b7af27fad3ce3321f3815b4d7f1310a51c1be11ee1812a9c855a8e7b109a_1280.jpg',
    doctorImageAlt: '徐醫師照片',
  },
  servicesContent: {
    sectionTitle: '診療項目',
    sectionSubtitle: '專業中醫診療服務',
    services: [
      {
        icon: 'Leaf',
        title: '中藥調理',
        subtitle: '慢性病與體質調理',
        desc: '針對慢性胃炎、失眠、疲勞等慢性病症，以中藥調理體質，改善根本問題。',
        image: 'https://pixabay.com/get/g7794a5d196396f119d3e192effde7dd6ac369b20bb86798f4f4ba5a7f038ec5aaecb78d507a6dc1e49c6b0d01521515fc55484faf4365cc7372844b12455bad8_1280.jpg',
        imageAlt: '中藥調理',
      },
      {
        icon: 'Zap',
        title: '針灸治療',
        subtitle: '疼痛與神經系統疾病',
        desc: '針對頸肩腰腿痛、頭痛、面癱等，以針灸疏通經絡，緩解疼痛。',
        image: 'https://pixabay.com/get/g1be3fe36c0961eee493a290e2b5a7a94c5f67d4ffbf79e3ef0c56070d80e958fb42e7c108f3a5ff271784535d1095670eb082e5bc564bf782c17e7525c4e1137_1280.jpg',
        imageAlt: '針灸治療',
      },
      {
        icon: 'Brain',
        title: '推拿按摩',
        subtitle: '筋骨關節問題',
        desc: '針對肌肉勞損、關節僵硬，以推拿手法鬆解筋膜，恢復活動能力。',
        image: 'https://pixabay.com/get/g4de965e807d8a188af5271688daf715b2b44e873092323e4d095b2b56e09f5a71b07a1f416539960bffd514ae66d9b5aa854a865c2d50cb720520b5ed40d4a4f_1280.jpg',
        imageAlt: '推拿按摩',
      },
      {
        icon: 'Heart',
        title: '養生保健',
        subtitle: '亞健康狀態調理',
        desc: '針對工作壓力大、睡眠不足、免疫力低下，提供整體養生方案。',
        image: 'https://pixabay.com/get/gbdf9c44b996406de7c6eb018a0552e9124219e1f773127a6f4dbf523c5c04535d72c981b524625db9b061001bf993a93ee70676b404be924823a456b3cba355a_1280.jpg',
        imageAlt: '養生保健',
      },
    ],
    processTitle: '診療流程',
    processSubtitle: '簡單四步，開始您的健康之旅',
    processSteps: [
      {
        icon: 'ClipboardList',
        step: '01',
        title: '預約',
        desc: '透過 WhatsApp 或電話預約診症時間',
      },
      {
        icon: 'Stethoscope',
        step: '02',
        title: '診症',
        desc: '詳細問診、望聞問切，了解病情',
      },
      {
        icon: 'FileText',
        step: '03',
        title: '處方',
        desc: '制定個人化治療方案',
      },
      {
        icon: 'RotateCcw',
        step: '04',
        title: '覆診',
        desc: '定期跟進，調整治療方案',
      },
    ],
  },
  galleryContent: {
    sectionTitle: '專業足跡',
    sectionSubtitle: '診所環境與治療實況',
    disclaimer: '所有照片僅供參考，實際治療效果因人而異',
    items: [
      {
        category: '診所環境',
        image: 'https://pixabay.com/get/g4d28a4469b91bc7b2dbea3fde9aca2714eae543e98fa56df710d1cb0addc47cdea5a274fac626886976850ffc535af46ffa605ecc0289f90f38d4cb45ecb89ae_1280.jpg',
        alt: '診所接待處',
      },
      {
        category: '治療室',
        image: 'https://pixabay.com/get/g8429127d1696f0ff0bca32d574b23495b4c2f4c9d84c41da4176fdf1205243a1fdd1f063a0669533f00301569b832146b283dc281edd85efc265facda6acd17c_1280.jpg',
        alt: '針灸治療室',
      },
      {
        category: '中藥房',
        image: 'https://pixabay.com/get/g7c425f2bf0740ab528ec751d8e1cc2600b55a17f584c64c1a01d220c528200d94ecadc94053ca6ee7705876c4f9896a4e00bb654f125e992fcc99d36b85a2361_1280.jpg',
        alt: '中藥配藥區',
      },
    ],
  },
  faqContent: {
    sectionTitle: '常見問題',
    sectionSubtitle: '您可能想了解的問題',
    items: [
      {
        q: '中醫治療需要多長時間見效？',
        a: '視乎病情與體質，一般慢性病需要 2-4 週調理期。急性症狀如感冒、疼痛，通常 1-3 次治療即可改善。我們會在首次診症時評估並告知預期療程。',
      },
      {
        q: '中藥有副作用嗎？',
        a: '我們使用的中藥均符合香港中醫藥管理委員會標準，並根據個人體質處方。初次服藥可能出現輕微腸胃不適，屬正常反應。如有嚴重不適，請立即聯絡我們。',
      },
      {
        q: '可以用醫療保險嗎？',
        a: '部分保險計劃涵蓋中醫治療，我們可提供正式收據供您向保險公司申請理賠。建議先向您的保險公司查詢保障範圍。',
      },
      {
        q: '需要空腹診症嗎？',
        a: '一般不需要。但如需進行舌診、脈診，建議避免食用會染色舌苔的食物（如咖啡、咖喱）至少 1 小時。',
      },
    ],
  },
  healthBlogContent: {
    sectionTitle: '健康專欄',
    description: '定期分享中醫養生知識與健康資訊',
    comingSoonText: '內容籌備中，敬請期待',
    ctaText: '訂閱通知',
  },
  contactContent: {
    sectionTitle: '聯絡與預約',
    sectionSubtitle: '歡迎預約診症或查詢',
    ctaText: 'WhatsApp 預約',
    transport: {
      title: '交通資訊',
      description: '診所位於旺角市中心，交通便利',
      busInfo: '巴士：1, 1A, 2, 6, 9, 203E（旺角站下車）',
    },
    clinicHours: [
      { day: '星期一', am: '9:00-13:00', pm: '14:00-18:00', eve: '19:00-21:00' },
      { day: '星期二', am: '9:00-13:00', pm: '14:00-18:00', eve: '休息' },
      { day: '星期三', am: '9:00-13:00', pm: '14:00-18:00', eve: '19:00-21:00' },
      { day: '星期四', am: '9:00-13:00', pm: '14:00-18:00', eve: '休息' },
      { day: '星期五', am: '9:00-13:00', pm: '14:00-18:00', eve: '19:00-21:00' },
      { day: '星期六', am: '9:00-13:00', pm: '休息', eve: '休息' },
      { day: '星期日', am: '休息', pm: '休息', eve: '休息' },
    ],
    hoursNote: '公眾假期休息，請提前預約',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=...',
  },
  footerContent: {
    brandSlogan: '傳承中醫智慧，守護您的健康',
    quickLinks: [
      { label: '關於醫師', href: '#about' },
      { label: '診療項目', href: '#services' },
      { label: '常見問題', href: '#faq' },
      { label: '聯絡預約', href: '#contact' },
    ],
    socialLinks: [
      { platform: 'facebook', label: 'Facebook', url: 'https://facebook.com/mingde-tcm' },
      { platform: 'youtube', label: 'YouTube', url: '' },
    ],
    disclaimer: '本網站內容僅供參考，不能替代專業醫療建議。如有健康問題，請諮詢註冊中醫師。',
  },
  tcmIntroContent: {
    sectionTitle: '中醫介紹',
    sectionSubtitle: '認識傳統中醫的智慧',
    contentTitle: '什麼是中醫？',
    content:
      '中醫學是一門源遠流長的傳統醫學，已有數千年歷史。它以陰陽五行、臟腑經絡為理論基礎，通過望聞問切四診合參，辨證論治，達到治病求本的效果。中醫強調整體觀念，認為人體是一個有機整體，治療時不僅針對局部症狀，更注重調整全身平衡。',
    highlights: [
      {
        icon: 'Leaf',
        title: '天然草本',
        desc: '使用天然中草藥，副作用少',
      },
      {
        icon: 'Zap',
        title: '針灸推拿',
        desc: '疏通經絡，調和氣血',
      },
      {
        icon: 'Heart',
        title: '整體調理',
        desc: '治病求本，標本兼治',
      },
    ],
  },
};
